var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`filters-button ${_vm.active ? 'active' : ''}`,on:{"click":_vm.handle_click}},[(_vm.icon)?_c('vb-icon',{staticClass:"filters-button--icon",attrs:{"name":_vm.icon,"size":19,"color":_vm.sass('info'),"icon_style":{
      '--color': _vm.sass('info'),
    }}}):_vm._e(),_c('div',{staticClass:"filters-button--button-text"},[_c('div',[_vm._v(_vm._s(_vm.text))]),(_vm.sub_text)?_c('div',{staticClass:"filters-button--button-subtext"},[_vm._v(" "+_vm._s(_vm.sub_text)+" ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }